import React, { useEffect, useState } from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import showNotify from "Helpers/Notify";
import { useSelector } from "react-redux";
import { ReactSVG } from "react-svg";
import MasticIcon from "Assets/svg/icon/Mastic_nv.svg";
import { DialogActions } from "@material-ui/core";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useTranslation } from 'react-i18next';

function FoamMasticUnit() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { selectedUser, selectedUnitCount,selectedProject } = useSelector((state) => ({
    selectedUser: state.project.selectedUser,
    selectedUnitCount: state.design.selectedUnitCount,
    selectedProject: state.project.selectedProject,
  }));
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [StypeU, setStypeU] = useState(null);
  const [UserC, setUserC] = useState(null);

  const [controls, setControls] = useSetState({
    consumedFoam: {
      type: "select",
      selectItems: [],
      value: "",
    },
    consumedMastic: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onFinish = async () => {
    const { consumedFoam, consumedMastic } = controls;
    try {
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdFom: consumedFoam.value.value,
        IdMastic: consumedMastic.value.value,
        ProjectIdSelected:  selectedProject.Id
      };
      const response = await DrawerService.postFoamMasticUnit(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: t('wasDoneSuccessfully'),
          customClass: "success",
        });
      }
      handleDialog();
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      let params;
      if ((StypeU === "1" || StypeU === "5") && UserC === "-") {
        params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          KeyRequestUser: selectedUser?.Key,
        };
      } else {
        params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
        };
      }

      const response = await DrawerService.GetComboFomMastik(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const list = response.data.Value;
        let listFoam = [];
        let listMastic = [];
        for (let i = 0; i < list.length; i++) {
          if (list[i].Type === 1) {
            listFoam.push({
              ...list[i],
              value: list[i].Id,
              label: list[i].Name,
            });
          } else if (list[i].Type === 2) {
            listMastic.push({
              ...list[i],
              value: list[i].Id,
              label: list[i].Name,
            });
          }
        }
        setControls({ consumedMastic: { selectItems: listMastic } });
        setControls({ consumedFoam: { selectItems: listFoam } });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  useEffect(() => {
    setStypeU(read("StypeU"));
    setUserC(read("UserC"));
  }, []);

  return (
    <>
      <MuiIconButton
        className="warning-fill"
        icon={<ReactSVG src={MasticIcon} />}
        title={<Translator id='FoamMasticUnit'/>}
        onClick={handleDialog}
        disabled={selectedUnitCount === 0}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <div className="dialogHeader">
          <p>
            <Translator id='FoamMasticUnit' noSpan />
          </p>
        </div>
        <DialogContent>
          {
            !loading ?
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MuiAutoComplete
                  autoSelect={true}
                  options={controls.consumedFoam.selectItems}
                  label={<Translator id={"consumedFoam"} />}
                  value={controls.consumedFoam.value}
                  id={"consumedFoam"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
              <Grid item xs={12}>
                <MuiAutoComplete
                  autoSelect={true}
                  options={controls.consumedMastic.selectItems}
                  label={<Translator id={"consumedMastic"} />}
                  value={controls.consumedMastic.value}
                  id={"consumedMastic"}
                  onChange={autoCompleteHandler}
                />
              </Grid>
            </Grid> : <MuiSkeleton xs={6} number={2} />
          }
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            onClick={onFinish}
            title={<Translator id="button_save" />}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default FoamMasticUnit;
